import React, { useState, useEffect, Suspense } from 'react';
import './App.css';
import axios from 'axios';
import LearningPlans from './components/LearningPlans';
import { useAppContext } from './contexts/AppContext';
import { Spinner } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CourseList from './components/CourseList';
import CourseLst from "./components/Pages/CoursesLst";
import LandingPage from "./components/Pages/LandingPage";

import TranscriptPDFButton from './components/Transcript/TranscriptPDFButton';
import ImportPlans from "./components/Pages/ImportPlans";
import CommonSchedulePage from "./components/Pages/Schedule/CommonSchedulePage";

function App() {
 
  const { currentUser, setCurrentUser, token, setToken } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);

  //const authorizeClient = async () => {

  //    try {
  //       // const cleanedDomain = process.env.REACT_APP_API_DOMAIN.replace("/courses", "");

  //        const response = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/auth${window.location.search}`, { withCredentials: true });
  //    setToken(response.data.access_token);
  //    axios.defaults.headers.common['Authorization'] = response.data.access_token;

  //  } catch (error) {
  //    console.log(`auth error: ${error}`)
  //  }
  //}
    const authorizeClient = async () => {
        try {
            await axios.get(
                `${process.env.REACT_APP_API_DOMAIN}/auth${window.location.search}`,
                {
                    withCredentials: true
                }
            );
        } catch (error) {
            console.log(`auth error: ${error}`);
        }
    };
  const getUserInfo = async (query) => {
    //101968 -> power user
    //13533 -> standard user
    let params = (new URL(document.location)).searchParams;
      let currentUser = params.get('user_id');
      //const cleanedDomain = process.env.REACT_APP_API_DOMAIN.replace("/courses", "");
      const response = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/user/${currentUser}${window.location.search}`, { withCredentials: true }); //LIVE
    // const response = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/user/13533`, { withCredentials: true }); //DEV
    const { user_id, username, first_name, last_name } = response.data.user_data;
    let activeTrainingRequirement = response.data.additional_fields.find(field => field.id == process.env.REACT_APP_TRAINING_FIELD_ID)
    let AHCASEligible = response.data.additional_fields.find(
      (field) => field.id === "16"
    );

    const userObj = {
      user_id,
      username,
      first_name,
      last_name,
      activeTrainingRequirement: activeTrainingRequirement?.value,
        AHCASEligible: (activeTrainingRequirement?.value === "Continuing Education" || activeTrainingRequirement?.value === null || activeTrainingRequirement?.value === "") ? AHCASEligible?.value : null,
    };

    //check if power user
      try {
          //const cleanedDomain = process.env.REACT_APP_API_DOMAIN.replace("/courses", "");
          const poweruserResp = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/poweruser/${currentUser}${window.location.search}`, { withCredentials: true }); //LIVE
      // const poweruserResp = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/poweruser/13533`, { withCredentials: true });//DEV
      const { permissions } = poweruserResp.data
      userObj.permissions = permissions;
      userObj.isPowerUser = true

    } catch (error) {
      userObj.isPowerUser = false;
    }

    setCurrentUser(userObj);
    setIsLoading(false);
  }


  // useEffect(() => {
  //   token === '' && authorizeClient();
  // }, [token]);

  //useEffect(() => {

  //  if (token && token != "") {
  //    getUserInfo();
  //  } else {
  //    authorizeClient();
  //  }

  //}, [token])

    useEffect(() => {
        const init = async () => {
            try {
                await authorizeClient(); // sets HttpOnly cookie
                await getUserInfo();     // cookie is automatically sent
            } catch (e) {
                console.log(e);
            }
        };

        init();
    }, []);

  return (

    <div>
      <Router>
      {isLoading ? (
        <div className="container p-3 mt-3">
          <div className="row">
            <h6 className="text-center color-grey pt-5">
              <Spinner animation="border" />
            </h6>
          </div>
        </div>
      ) : (
        <Routes>
            {/* <Route path="/" element={<LearningPlans />} /> */}
            {<Route path="/" element={<LandingPage />} />}
            <Route path="/transcript" element={<TranscriptPDFButton />} />
            {/* <Route path="/courses" element={<CourseList />} /> */}
            <Route path="/courses" element={<CourseLst />} />
            {/* <Route path="/languages" element={<LandingPage />} /> */}
            <Route path="/import-plans" element={<ImportPlans />} />
            <Route path="/schedule" element={<CommonSchedulePage />} />
          </Routes>
        )}
      </Router>
    </div>

  );
}

export default App;
